// remoteConfig.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_REMOTE_CONFIG_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';
import env from '../resource/env.js';
import {
  TRAILER_BLOCKER_URL,
  LANDING_BLOCKER_URL,
} from '../RemoteConfigKeys.js';

import TrailerBlockImageSource from '../../img/img_cover_under_18.svg';
import LandingBlockImageSource from '../../img/img_popup_under_18.svg';

export const defaultState = fromJS({
  [TRAILER_BLOCKER_URL]: TrailerBlockImageSource,
  [LANDING_BLOCKER_URL]: LandingBlockImageSource,
  ...env,
});

/**
 * Remote config.
 * @module reducer/remoteConfig
 */
const remoteConfig = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_REMOTE_CONFIG_DATA:
      return _MERGE_REMOTE_CONFIG_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge remote config data
 * @kind reducer/actionType
 * @name MERGE_REMOTE_CONFIG_DATA
 * @param {object} remoteConfigData - config data from pusher.
 * @return {Immutable.Map} New state
 */
const _MERGE_REMOTE_CONFIG_DATA = remoteConfigData => state => {
  return state.mergeDeep(remoteConfigData);
};

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default remoteConfig;
